module.exports = __webpack_public_path__ + "img/anti_racism_campaign_CCNCSJ.50fb83ac.jpeg";